<template>
    <header class="navbar-fixed">
        <nav>
            <div class="nav-wrapper">
                <a href="#" data-target="slide-out" class="sidenav-trigger"><i class="material-icons">menu</i></a>
                <img src="../../assets/icon.png" class="hide-on-small-only" alt="KPIs PROSIC">&nbsp;
                <router-link to="/" class="brand-logo"> KPIs <span class="hide-on-med-and-down">PROSIC</span></router-link>
                <ul id="nav-mobile" class="right hide-on-med-and-down">

                    <li><a @click="logout" href="#" id="btnLogout" ><i class="material-icons left">exit_to_app</i>Salir</a></li>
                </ul>
            </div>
        </nav>
    </header>
</template>
<script>
export default {
  methods: {
    logout() {
      // we excecure the centralized method (action) located in sotore/modules/auth.js
      this.$store.dispatch('singUserOut');
    },
  },
};
</script>
<style scoped>
nav {
    background-color: var(--secondary-dark-color);
}
nav #menu-icon {
    margin-left: 16px;
}
nav img{
    margin: 9px;
    height: 46px;
    width: auto;
    margin-left: 16px;
}
</style>
